import Head from "next/head";
import { authorToSchema, resolveArticleAuthor } from "../lib/authors";

const SITE_URL = "https://przyjazne-deklaracje.pl";
const PUBLISHER_LOGO =
	"https://przyjazne-deklaracje.pl/resources/images/logo/przyjazne-deklaracje/logo-desktop.svg";

function normalizeArticleUrl(section, id) {
	const cleanSection = String(section || "").replace(/^\/+|\/+$/g, "");
	const cleanId = String(id || "").replace(/^\/+|\/+$/g, "");

	return `${SITE_URL}/${cleanSection}/${cleanId}/`;
}

function uniqueImages(postData) {
	return [
		postData?.seoImage,
		postData?.imageMobile,
		postData?.imageTablet,
		postData?.imageDesktop,
	].filter((value, index, values) => value && values.indexOf(value) === index);
}

function serializeJsonLd(data) {
	return JSON.stringify(data)
		.replace(/</g, "\\u003c")
		.replace(/\u2028/g, "\\u2028")
		.replace(/\u2029/g, "\\u2029");
}

export default function ArticleStructuredData({ postData, section }) {
	if (!postData?.id || !section) {
		return null;
	}

	const url = normalizeArticleUrl(section, postData.id);
	const author = resolveArticleAuthor(postData);
	const schemaAuthor = authorToSchema(author);
	const images = uniqueImages(postData);

	const schema = {
		"@context": "https://schema.org",
		"@type": "Article",
		"@id": `${url}#article`,
		url,
		mainEntityOfPage: {
			"@type": "WebPage",
			"@id": url,
		},
		headline: postData.title,
		description: postData.description,
		image: images.length ? images : undefined,
		datePublished: postData.datePublication,
		dateModified: postData.dateUpdate || postData.datePublication,
		author: schemaAuthor,
		publisher: {
			"@type": "Organization",
			"@id": `${SITE_URL}/#organization`,
			name: "Przyjazne Deklaracje",
			url: `${SITE_URL}/`,
			logo: {
				"@type": "ImageObject",
				url: PUBLISHER_LOGO,
			},
		},
		inLanguage: "pl-PL",
	};

	Object.keys(schema).forEach((key) => {
		if (schema[key] === undefined || schema[key] === null || schema[key] === "") {
			delete schema[key];
		}
	});

	return (
		<Head>
			<script
				key="article-schema"
				id="article-schema"
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: serializeJsonLd(schema),
				}}
			/>
		</Head>
	);
}
